import {IPersonResponse} from './person'

export type IUserResponse = {
  name: string
  cpf: string
  email: string
  phone: string
  phoneCode?: number
  emailVerified: string
  person: IPersonResponse
  franchises: {id?: number; name: string; userFranchise?: {active: boolean}}[]
  roles: {name: string}[]
  firstLogin: boolean
  active: boolean
  notificationPreference: number
  createdAt: string
  updatedAt: string
}

export type IUserProfile = {
  name: string
  cpf: string
  phone: string
  phoneCode?: number
  notification_preference: number
}

export type IUserProfilePhoto = {
  profilePhoto: string | File
}

export interface IUpdateEmail {
  newEmail: string
  confirmPassword: string
}
export interface TUpdateEmailRequest {
  email: string
  current_password: string
}

export interface IUpdatePassword {
  currentPassword: string
  newPassword: string
  passwordConfirmation: string
}

export interface TUpdatePasswordRequest {
  current_password: string
  password: string
  password_confirmation: string
}

export type TUserFranchiseLink = {
  id: number
  name?: string
  active: boolean
}

export type TUserResquest = {
  name: string
  cpfUser: string
  email: string
  phoneUser: string
  person: IPersonResponse
  password?: string
  franchises: Array<TUserFranchiseLink>
  roles: Array<number>
  active: boolean
}

export type TEditUserRequest = {
  name: string
  cpf: string
  email: string
  phone: string
  person?: number
  password?: string
  franchises: Array<TUserFranchiseLink>
  roles: Array<number>
  active: boolean
}
export type TUser = {
  id: number
  personId: number
  name: string
  cpf: string
  email: string
  phone: string
  firstLogin: boolean
  createdAt: string
  updatedAt: string
}
export type TCreateUserRequest = {
  name: string
  cpf: string
  email: string
  phone: string
  person?: number
  password?: string
  franchises: Array<TUserFranchiseLink>
  roles: Array<number>
  active: boolean
}

export const userInitValues: any = {
  type: 2,
  name: '',
  document: '',
  franchiseEmail: '',
  socialReason: '',
  fantasyName: '',
  email: '',
  addresses: [
    {
      zipCode: '',
      street: '',
      neighborhood: '',
      number: '',
    },
  ],
  active: true,
}

export type UserRequest = {
  id?: string
  name: string
}

export type SaleApproversRequest = {
  users: Number[]
}
